import { createFileRoute, redirect } from "@tanstack/react-router";

// Index of a school scope: today's lessen, where a docent's day starts.
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/")({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/$school/lessons/today",
      params: {
        locale: params.locale,
        schoolyear: params.schoolyear,
        school: params.school,
      },
    });
  },
});
